import React, { useState, useRef } from "react";
import { Link as GatsbyLink } from "gatsby"
import { useForm, Controller } from "react-hook-form";
import SignaturePad from "react-signature-canvas";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import styled from '@emotion/styled'

import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  FormControl,
  FormLabel,
  Textarea,
  Input,
  Button,
  HStack,
  CheckboxGroup,
  Checkbox,
  Flex,
  Text,
  Spinner,
  Icon,
  Link,
  Heading,
  Table,
  Td,
  Tr,
  Th,
  Thead,
  Tbody,
  OrderedList,
  ListItem,
  RadioGroup,
  VStack,
  Radio
} from "@chakra-ui/react";
import { BsXCircle, BsCheck2Circle } from "react-icons/bs";
import { VscWarning } from "react-icons/vsc";

const schema = yup.object().shape({
  applicantName: yup.string().required("Name is required"),
  phone: yup
    .string()
    .required("Phone is required")
    .matches(
      /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
      "Invalid phone number"
    ),
  email: yup
    .string()
    .required("Email is required")
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Invalid email"
    ),
  mailingAddress: yup.string().required("Mailing address is required"),
  businessName: yup.string().required("Business name is required"),
  nameEvent: yup.string().required("Event name is required"),
  typeEvent: yup.string().required("Event type is required"),
  eventDates: yup.string().required("Event dates are required"),
  numberOfParticipants: yup.string().required("Number of participants is required"),
  numberOfEvents: yup.string().required("Number of events is required"),
  time: yup.string().required("Time is required"),
  numberOfHoursPerEvent: yup.string().required("Number of hours per event is required"),
  servingBeerAndWine: yup.string().required("Required").nullable(),
  retailSales: yup.string().required("Required").nullable(),
  applicantSignature: yup
    .string()
    .required("Signature is required.")
    .matches(
      /^data:image\/(?:gif|png|jpeg|bmp|webp|svg\+xml)(?:;charset=utf-8)?;base64,(?:[A-Za-z0-9]|[+/])+={0,2}/,
      "Signature must be png"
    ),
});

const ParkReservationForm = () => {
  const [processing, setProcessing] = useState(false);
  const [succeeded, setSucceeded] = useState(false);
  const [achSucceeded, setAchSucceeded] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    control,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    resolver: yupResolver(schema),
  });


  const watchData = watch();
  console.log(watchData)

  const scrollTop = () => {
    window.scrollTo(0, 0);
  };

const errorStyles = {
    color: "#bf1650",
    fontSize: "1rem",
  };

  const SectionHeading = styled(Heading)`
	font-family: 'proxima-nova', sans-serif;
	margin-bottom: 1rem;
	font-size: 1.5rem !important;
`;


function RequiredSpan() {
  return <span style={{ color: "#bf1650" }}>*</span>;
}
// create a Ref to access our form element
const formRef = useRef(null)

const FormSuccess = () => (
<Box my="20">
<Alert status="success"
  variant="subtle"
  flexDirection="column"
  alignItems="center"
  justifyContent="center"
  textAlign="center"
  >
<AlertIcon boxSize='40px' mr={0}/>
  <AlertTitle mb="4">
    Application submitted successfully!
    </AlertTitle>
    <AlertDescription maxWidth='md'>
    Thank you for submitting your application. We will be in touch with you shortly.<br />
    Please check your email for a copy of your application for your records.
</AlertDescription>
</Alert>
</Box>
)

const FormSuccessForAchPayment = () => {
scrollTop();
return (
  <Box my="20">
    <Alert status="success"
      variant="subtle"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      >
    <AlertIcon boxSize='40px' mb="4"/>
    <AlertTitle mb="4">
        Thank you for your application. We will be in touch with you shortly.<br />
        Please check your email for a copy of your application for your records.
        </AlertTitle>
      {/* <AlertTitle mb="4">
        Please proceed to <Link href="https://www.xpressbillpay.com/#/?org=driggs10632" target="_blank" rel="noopener noreferrer">Xpress Billpay</Link> to complete your application. The amount you owe is <strong>$50</strong>.
        </AlertTitle> */}
        {/* <XpressBillPay /> */}
    </Alert>
  </Box>
);
};


const sendMailgunFormData = async (data) => {
//event.preventDefault()
setProcessing(true);

if (!formRef.current) {
    console.log('something went wrong with the ref');
}

const formData = new FormData(formRef.current);

// convert signature to blob
const applicantSignatureBlob = await (await fetch(watchData.applicantSignature)).blob([applicantSignatureBlob], "applicantSignature.png");

// append blob to formData
formData.append("applicantSignature", applicantSignatureBlob, "applicantSignature.png");

const convertArrayToObject = (array, key) => {
  const initialValue = {};
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key]]: item,
    };
  }, initialValue);
};

// Convert license array to object - parsing function only returns the last value
convertArrayToObject(watchData.venueLocation, "venueLocations");


formData.append('venueLocations', JSON.stringify(watchData.venueLocation));

// Use console.log() to see the data that is being sent to the server
console.log(Array.from(formData.entries()));

fetch('/.netlify/functions/send-park-reservation', {
       method: 'POST',
       body: formData,
       // don't send headers due to boundary problem 
   })
   // Convering the response to JSON breaks status code
   .then(res => {
       console.log(res)
          if (res.status === 200) {
                setAchSucceeded(true)
                setProcessing(false)
                reset()
                scrollTop()
            } else {
                setSucceeded(false)
                console.log("network error")
                alert("Network error. Please try again later.")
            }
   }
)
};

  {
    /* Signature Pad */
  }
  let sigCanvas = useRef({});

  const formatIntoPng = () => {
    if (sigCanvas.current) {
      const dataURL = sigCanvas.current.toDataURL();
      return dataURL;
    }
  };

  const clear = () => sigCanvas.current.clear();

  return (
    
      <Box id="theForm">
       {succeeded 
            ? (<FormSuccess />)
          : achSucceeded 
          ? (<FormSuccessForAchPayment />)
          : (
          <>
            <form onSubmit={handleSubmit(sendMailgunFormData)} ref={formRef}>
              <Box my="8">
                <Text as="i" p="4" bg="#eee" display="block" textAlign="center">
                  Please call the City Clerk at{" "}
                  <Link href="tel:3542362">354-2362</Link> for information on
                  facility description. <Link as={GatsbyLink} to="/departments/parks-and-recreation">Facility descriptions here</Link>.
                </Text>
              </Box>

              <Flex w="100%" flexWrap="wrap" mb="8">
                <Box w={{ base: "100%", md: "50%" }} pr={{ base: 0, md: 4 }}>
                  <FormLabel>Applicant Name:<RequiredSpan /></FormLabel>
                  <Input
                    type="text"
                    {...register("applicantName")}
                    autoComplete="on"
                  />
                  <p style={errorStyles}>
                    {errors.applicantName && (
                      <HStack spacing="5px">
                        <VscWarning />{" "}
                        <Box>{errors.applicantName?.message}</Box>
                      </HStack>
                    )}
                  </p>
                </Box>
                <Box w={{ base: "100%", md: "50%" }}>
                  <FormLabel>Phone:<RequiredSpan /></FormLabel>
                  <Input
                    type="text"
                    {...register("phone")}
                    autoComplete="on"
                  />
                  <p style={errorStyles}>
                    {errors.phone && (
                      <HStack spacing="5px">
                        <VscWarning /> <Box>{errors.phone?.message}</Box>
                      </HStack>
                    )}
                  </p>
                </Box>
              </Flex>

              <Flex w="100%" flexWrap="wrap" mb="8">

                <Box w={{ base: "100%", md: "50%" }} pr={{ base: 0, md: "4" }}>
                  <FormLabel>Email:<RequiredSpan /></FormLabel>
                  <Input
                    type="email"
                    {...register("email")}
                    autoComplete="on"
                  />
                  <p style={errorStyles}>
                    {errors.email && (
                      <HStack spacing="5px">
                        <VscWarning /> <Box>{errors.email?.message}</Box>
                      </HStack>
                    )}
                  </p>
                </Box>
                <Box mb="8" w={{ base: "100%", md: "50%" }}>
                <FormLabel>Mailing Address:</FormLabel>
                <Input
                  type="text"
                  {...register("mailingAddress")}
                  autoComplete="on"
                />
                {errors.mailingAddress && (
                  <HStack spacing="5px" style={errorStyles}>
                    <VscWarning /> <Box>{errors.mailingAddress?.message}</Box>
                  </HStack>
                )}
              </Box>
              </Flex>

              

              <Box mb="8">
                <FormLabel>Business/Organization/Sponsor Name:<RequiredSpan /> </FormLabel>
                <Input
                  type="text"
                  {...register("businessName")}
                  autoComplete="on"
                />
                {errors.businessName && (
                  <HStack spacing="5px" style={errorStyles}>
                    <VscWarning /> <Box>{errors.businessName?.message}</Box>
                  </HStack>
                )}
              </Box>

              <Box mb="8">
                <FormLabel>Name of Event:<RequiredSpan /></FormLabel>
                <Input
                  type="text"
                  {...register("nameEvent")}
                  autoComplete="on"
                />
                {errors.nameEvent && (
                  <HStack spacing="5px" style={errorStyles}>
                    <VscWarning /> <Box>{errors.nameEvent?.message}</Box>
                  </HStack>
                )}
              </Box>

              <Box mb="8">
                <FormLabel>Type or Purpose of Event:<RequiredSpan /> </FormLabel>
                <Textarea {...register("typeEvent")} autoComplete="on" />
                {errors.typeEvent && (
                  <HStack spacing="5px" style={errorStyles}>
                    <VscWarning /> <Box>{errors.typeEvent?.message}</Box>
                  </HStack>
                )}
              </Box>

              <Flex w="100%" flexWrap="wrap" mb="8">
                <Box w={{ base: "100%", md: "33%" }}>
                  <FormLabel>Event Date(s)<RequiredSpan /></FormLabel>
                  <Textarea
                    type="textarea"
                    {...register("eventDates")}
                    autoComplete="on"
                  />
                  <p style={errorStyles}>
                    {errors.eventDates && (
                      <HStack spacing="5px">
                        <VscWarning /> <Box>{errors.eventDates?.message}</Box>
                      </HStack>
                    )}
                  </p>
                </Box>
                <Box w={{ base: "100%", md: "33%" }} pl={{ base: 0, md: "4" }}>
                  <FormLabel>Number of Participants<RequiredSpan /></FormLabel>
                  <Input
                    type="number"
                    {...register("numberOfParticipants")}
                    autoComplete="on"
                  />
                  <p style={errorStyles}>
                    {errors.numberOfParticipants && (
                      <HStack spacing="5px">
                        <VscWarning />{" "}
                        <Box>{errors.numberOfParticipants?.message}</Box>
                      </HStack>
                    )}
                  </p>
                </Box>
                <Box w={{ base: "100%", md: "33%" }} pl={{ base: 0, md: "4" }}>
                  <FormLabel>Number of Events<RequiredSpan /></FormLabel>
                  <Input
                    type="number"
                    {...register("numberOfEvents")}
                    autoComplete="on"
                  />
                  <p style={errorStyles}>
                    {errors.numberOfEvents && (
                      <HStack spacing="5px">
                        <VscWarning />{" "}
                        <Box>{errors.numberOfEvents?.message}</Box>
                      </HStack>
                    )}
                  </p>
                </Box>
              </Flex>

              <Flex w="100%" flexWrap="wrap" mb="8">
                <Box w={{ base: "100%", md: "33%" }}>
                  <FormLabel>Time(s):<RequiredSpan /></FormLabel>
                  <Textarea type="textarea" {...register("time")} autoComplete="on" />
                  <p style={errorStyles}>
                    {errors.time && (
                      <HStack spacing="5px">
                        <VscWarning /> <Box>{errors.time?.message}</Box>
                      </HStack>
                    )}
                  </p>
                </Box>
                <Box w={{ base: "100%", md: "33%" }} pl={{ base: 0, md: "4" }}>
                  <FormLabel>Number of hours per event<RequiredSpan /></FormLabel>
                  <Input
                    type="number"
                    {...register("numberOfHoursPerEvent")}
                    autoComplete="on"
                  />
                  <p style={errorStyles}>
                    {errors.numberOfHoursPerEvent && (
                      <HStack spacing="5px">
                        <VscWarning />{" "}
                        <Box>{errors.numberOfHoursPerEvent?.message}</Box>
                      </HStack>
                    )}
                  </p>
                </Box>
              </Flex>

              <Box mb="8">
                <SectionHeading>
                  Choose a venue(s):
                </SectionHeading>
                <Table variant="simple">
                  <Thead>
                    <Tr>
                      <Th fontFamily={'proxima-nova, sans-serif'} fontSize="1rem">Venue: City Park</Th>
                      <Th fontFamily={'proxima-nova, sans-serif'} fontSize="0.85rem">
                        Reservation Fee - Non Refundable Single Event: $25 +
                        hourly charge
                      </Th>
                      <Th fontFamily={'proxima-nova, sans-serif'} fontSize="1rem">
                        Reservation Fee - Non Refundable Multi-Event: $50 +
                        hourly charge
                      </Th>
                    </Tr>
                  </Thead>
                  <CheckboxGroup defaultValue="">
                  <Tbody>
                    <Tr>
                      <Td>
                      <Checkbox
                        value="Ball Field / Multi-Purpose Field 2"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Ball Field / Multi-Purpose Field 2
                      </Checkbox>
                      </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                    <Tr>
                      <Td>
                      <Checkbox
                        value="Multi-Purpose Field 1"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Multi-Purpose Field 1
                      </Checkbox>
                      </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                    <Tr>
                      <Td><Checkbox
                        value="City Park Basketball Court"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Basketball Court
                        </Checkbox>
                        </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                    <Tr>
                      <Td><Checkbox
                        value="Pavilion / Stage"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Pavilion / Stage
                        </Checkbox>
                        </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                  </Tbody>
                  <Thead>
                    <Tr>
                      <Th fontFamily={'proxima-nova, sans-serif'} fontSize="1rem">Venue: Lions Park</Th>
                      <Th fontFamily={'proxima-nova, sans-serif'} fontSize="0.85rem">
                        Reservation Fee - Non Refundable Single Event: $25 +
                        hourly charge
                      </Th>
                      <Th fontFamily={'proxima-nova, sans-serif'} fontSize="0.85rem">
                        Reservation Fee - Non Refundable Multi-Event: $50 +
                        hourly charge
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td><Checkbox
                        value="Ball Field / Multi-Purpose Field"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Ball Field / Multi-Purpose Field
                        </Checkbox>
                        </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                  </Tbody>
                  <Thead>
                    <Tr>
                      <Th fontFamily={'proxima-nova, sans-serif'} fontSize="1rem">Venue: Valley Ctr</Th>
                      <Th fontFamily={'proxima-nova, sans-serif'} fontSize="0.85rem">
                        Reservation Fee - Non Refundable Single Event: $25 +
                        hourly charge
                      </Th>
                      <Th fontFamily={'proxima-nova, sans-serif'} fontSize="0.85rem">
                        Reservation Fee - Non Refundable Multi-Event: $50 +
                        hourly charge
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td><Checkbox
                        value="Multi-Purpose Field"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Multi-Purpose Field
                      </Checkbox>
                        </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                  </Tbody>
                  <Thead>
                    <Tr>
                      <Th fontFamily={'proxima-nova, sans-serif'} fontSize="1rem">Venue: Primrose Park</Th>
                      <Th fontFamily={'proxima-nova, sans-serif'} fontSize="0.85rem">
                        Reservation Fee - Non Refundable Single Event: $25 +
                        hourly charge
                      </Th>
                      <Th fontFamily={'proxima-nova, sans-serif'} fontSize="0.85rem">
                        Reservation Fee - Non Refundable Multi-Event: $50 +
                        hourly charge
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td><Checkbox
                        value="Primrose Park Basketball Court"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Basketball Court
                        </Checkbox>
                        </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                    <Tr>
                      <Td>
                      <Checkbox
                        value="Volleyball Court"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Volleyball Court
                        </Checkbox>
                        </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                    <Tr>
                      <Td>
                      <Checkbox
                        value="Primrose Multi-Purpose Field"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Multi-Purpose Field
                        </Checkbox>
                        </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                    <Tr>
                      <Td>
                      <Checkbox
                        value="Pickleball Court 1"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Pickleball Court No. 1 (Southeast)<br /><span style={{fontSize: 'smaller', fontWeight: 'bold'}}>Public Events Only</span>
                        </Checkbox>
                        </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                    <Tr>
                      <Td>
                      <Checkbox
                        value="Pickleball Court 2"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Pickleball Court No. 2 (South-Center)<br /><span style={{fontSize: 'smaller', fontWeight: 'bold'}}>Public Events Only</span>
                        </Checkbox>
                        </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                    <Tr>
                      <Td>
                      <Checkbox
                        value="Pickleball Court 3"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Pickleball Court No. 3 (Southewest)<br /><span style={{fontSize: 'smaller', fontWeight: 'bold'}}>Public Events Only</span>
                        </Checkbox>
                        </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                    <Tr>
                      <Td>
                      <Checkbox
                        value="Pickleball Court 4"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Pickleball Court No. 4 (Northeast)
                        </Checkbox>
                        </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                    <Tr>
                      <Td>
                      <Checkbox
                        value="Pickleball Court 5"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Pickleball Court No. 5 (North-Center)
                        </Checkbox>
                        </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                    <Tr>
                      <Td>
                      <Checkbox
                        value="Pickleball Court 6"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Pickleball Court No. 6 (Northwest)
                        </Checkbox>
                        </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                  </Tbody>
                  <Thead>
                    <Tr>
                      <Th fontFamily={'proxima-nova, sans-serif'} fontSize="1rem">Venue: 5th Street</Th>
                      <Th fontFamily={'proxima-nova, sans-serif'} fontSize="0.85rem">
                        Reservation Fee - Non Refundable Single Event: $25 +
                        hourly charge
                      </Th>
                      <Th fontFamily={'proxima-nova, sans-serif'} fontSize="0.85rem">
                        Reservation Fee - Non Refundable Multi-Event: $50 +
                        hourly charge
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td><Checkbox
                        value="Skate Park"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Skate Park
                        </Checkbox>
                        </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                    <Tr>
                      <Td>
                      <Checkbox
                        value="Bike Course"
                        name="venueLocation"
                        {...register("venueLocation")}
                      >
                        Bike Course
                        </Checkbox>
                        </Td>
                      <Td>$4.25/hour</Td>
                      <Td>$4.25/hour</Td>
                    </Tr>
                  </Tbody>
                  </CheckboxGroup>  
                </Table>
              </Box>

              <Box mb="8">
                <OrderedList>
                  <ListItem>
                  <FormControl>
                <FormLabel as="legend">
                Will you be serving beer and/or wine (alcohol prohibited in City Park)?<RequiredSpan />
                </FormLabel>
                <RadioGroup defaultValue="">
                  <HStack direction="column" gap="4">
                    <Radio
                      value="Yes"
                      name="servingBeerAndWine"
                      {...register("servingBeerAndWine")}
                    >
                      Yes
                    </Radio>
                    <Radio
                      value="No"
                      name="servingBeerAndWine"
                      {...register("servingBeerAndWine")}
                    >
                      No
                    </Radio>
                  </HStack>
                </RadioGroup>
              </FormControl>
              <p style={errorStyles}>
                      {errors.servingBeerAndWine && (
                        <HStack spacing="5px">
                          <VscWarning />{" "}
                          <Box>{errors.servingBeerAndWine?.message}</Box>
                        </HStack>
                      )}
                    </p>
                    <Text my="4">
                       If yes, beer/wine sales license is required.
                      </Text>
                  </ListItem>
                  <ListItem>
                    <FormControl>
                      <FormLabel>
                        Will you have retail sales at the event?<RequiredSpan />
                      </FormLabel>
                      <RadioGroup defaultValue="">
                       <HStack direction="column" gap="4">
                          <Radio
                          value="Yes"
                          name="retailSales"
                          {...register("retailSales")}
                        >
                          Yes
                        </Radio>
                        <Radio
                          value="No"
                          name="retailSales"
                          {...register("retailSales")}
                        >
                          No
                        </Radio>
                       </HStack>
                     </RadioGroup>
                     <p style={errorStyles}>
                      {errors.retailSales && (
                        <HStack spacing="5px">
                          <VscWarning />{" "}
                          <Box>{errors.retailSales?.message}</Box>
                        </HStack>
                      )}
                    </p>
                      <Text my="4">
                        If yes, non property sales tax (resort tax) must be
                        collected
                      </Text>
                    </FormControl>
                    
                  </ListItem>
                  <ListItem>
                    <Text>All fees due at time of reservation</Text>
                  </ListItem>
                </OrderedList>
              </Box>

              <Box mb="8" align="center">
  
                {/* <Box my="12">
                  <Alert 
                    variant="subtle"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    textAlign="center"
                    >
                  <AlertIcon boxSize='40px' my="4"/>
                    <AlertDescription fontWeight="600">
                    For events/seasons with
                  greater than 20 participants, additional toilet facilities and
                  garbage can provisions must be provided by the event sponsor
                  in a number approved by the Public Works Director. Field
                  preparation is the responsibility of the event sponsor with
                  approval by the Public Works Director
                  </AlertDescription>
                  </Alert>
                </Box> */}
                
                <Box my="12">
                  <Alert status="warning"
                    variant="subtle"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    textAlign="center"
                    >
                  <AlertIcon boxSize='40px' my="4"/>
                    <AlertTitle mb="4">
                    THERE ARE NO TRASH RECEPTACLES AT THE PARKS: CARRY IN-CARRY
                      OUT!
                      </AlertTitle>
                  </Alert>
                </Box>
              </Box>

              <Box>
                <SectionHeading textAlign="center">
                  TERMS &amp; RESPONSIBILITIES
                </SectionHeading>
              </Box>

              <Box mb="8">
                <OrderedList>
                  <ListItem>
                    <Text my="4">
                     Parks reserved on a first come, first served basis, except that the City may request those submitting <b>reservation forms spanning weeks or months</b> to <b>coordinate</b> with other organizations or programs requesting conflicting reservations and/or to submit revised reservation forms to <b>ensure adequate access</b> for other significant programs and the public.
                    </Text>
                  </ListItem>
                  <ListItem>
                    <Text my="4">
                      No reservations for summer seasons will be taken until <b>January 15</b> or the closest business after, of each year.
                    </Text>
                  </ListItem>
                  <ListItem>
                    <Text my="4">
                     <b>All fees due at time of reservation</b>
                    </Text>
                  </ListItem>
                  <ListItem>
                    <Text my="4">
                      <b>For events/seasons with &gt;200 participants</b>, additional toilet facilities and garbage can provisions must be provided by the event sponsor in a number approved by the Public Works Director.
                    </Text>
                  </ListItem>
                  <ListItem>
                    <Text my="4">
                      Field preparation is the responsibility of the event sponsor with approval by the Public Works Director.
                    </Text>
                  </ListItem>
                  <ListItem>
                    <Text my="4">
                      Return facility back to original condition and in a clean state (garbage, banner, etc.) Any damage deemed unnecessary by City staff will be billed to applicant for repairs.
                    </Text>
                  </ListItem>
                  <ListItem>
                    <Text my="4">
                      Turn of all field/court lights after use.
                    </Text>
                  </ListItem>
                  <ListItem>
                    <Text my="4">
                      Contact Public Works if you have any facility <b>emergencies</b> after business hours.
                    </Text>
                  </ListItem>
                </OrderedList>
              </Box>

              <Box mb="8" align="center">
                <Text as="b">
                  I understand and agree to the terms and responsibilities
                  listed above that are required to use the venue
                </Text>
              </Box>

              <Flex w="100%" flexWrap="wrap" mb="8">
                <Box mb="8" w={{ base: "100%", md: "50%" }}>
                  <FormControl isInvalid={!!errors?.applicantSignature?.message}>
                    <FormLabel>Applicant Signature</FormLabel>
                    <Box>
                      <Controller
                        name="applicantSignature"
                        control={control}
                        render={({ field }) => (
                          <SignaturePad
                            ref={sigCanvas}
                            onEnd={() =>
                              field.onChange(
                                formatIntoPng(sigCanvas.current.toDataURL())
                              )
                            }
                            penColor="black"
                            canvasProps={{
                              style: {
                                border: "1px solid #e2e8f0",
                                borderRadius: "0.375rem",
                                width: "100%",
                                backgroundColor: "white",
                              },
                            }}
                          />
                        )}
                      />

                      {errors.applicantSignature && (
                        <HStack spacing="5px" style={errorStyles}>
                          <VscWarning /> <Box>{errors.applicantSignature?.message}</Box>
                        </HStack>
                      )}
                    </Box>
                    <Box>
                      <input
                        type="hidden"
                        value={new Date()}
                        name="timestamp"
                        {...register("timestamp", { required: true })}
                      />
                    </Box>
                  </FormControl>
                  <Box my="2" textAlign="right">
                    <Button size="sm" onClick={clear} colorScheme="red">
                      <Icon as={BsXCircle} mr="2" />
                      Clear Signature
                    </Button>
                  </Box>
                </Box>
              </Flex>

              <Box my="8">
                <Button type="submit" textAlign="left">
                  {processing ? (
                    <Spinner />
                  ) : succeeded ? (
                    "Submitted!"
                  ) : (
                    "Submit"
                  )}
                </Button>
              </Box>
            </form>
          </>
        )}
      </Box>
  );
};

export default ParkReservationForm;
